<script lang="ts">
  import { captions } from './captions.ts';
  import { settings } from '../settings.ts';
</script>

<!-- Live-Region existiert immer, damit Screenreader neue Untertitel zuverlässig ansagen -->
<div class="caps" aria-live="polite" data-testid="captions">
  {#if $settings.subtitles}
    {#each $captions as c (c.id)}<span>{c.text}</span>{/each}
  {/if}
</div>

<style>
  .caps {
    position: fixed;
    left: calc(12px + var(--safe-left));
    bottom: calc(100px + var(--safe-bottom));
    display: grid;
    gap: 4px;
    z-index: 45;
    pointer-events: none;
  }
  span {
    background: rgba(12, 20, 34, 0.85);
    color: var(--amber3);
    padding: 4px 10px;
    border-radius: 8px;
    font-size: 0.9rem;
    font-style: italic;
  }
</style>
